// product feed is missing from all tools.

import { ProductFeedPage } from '../configs/tools/shared-library/product-feed';

export const productFeed = ProductFeedPage;
